import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-datasets',
    templateUrl: './datasets.component.html',
    styleUrls: ['./datasets.component.css'],
    standalone: false
})
export class DatasetsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
